(function () {
  var audienceCache = Object.create(null);
  var audienceRequests = Object.create(null);
  var scheduled = false;

  function priceMode() {
    var root = document.documentElement;
    if (root.getAttribute('data-provider-customer') === 'true') return 'provider';
    // Guests and retail accounts pay the Shopify variant price. The Amazon
    // metafield is one price per product, so it cannot be shown as the price.
    return 'retail';
  }

  function formatCents(cents) {
    var amount = (Number(cents) / 100).toFixed(2);
    var format = (window.theme && window.theme.settings && window.theme.settings.moneyWithCurrencyFormat) || '${{amount}} USD';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function setNodeText(node, text) {
    if (!node || node.textContent.trim() === text) return;
    node.textContent = text;
  }

  function applyThemePrice(el, text) {
    if (!text) return;
    el.classList.remove('price--on-sale');
    el.querySelectorAll('.price-item--sale, .price__regular .price-item--regular').forEach(function (node) {
      if (node.closest('s')) return;
      setNodeText(node, text);
    });
  }

  function themePriceText(el, mode) {
    if (mode === 'provider') {
      var cents = parseInt(el.getAttribute('data-provider-cents'), 10);
      if (!cents) return '';
      var maxCents = parseInt(el.getAttribute('data-provider-cents-max') || String(cents), 10);
      var formatted = formatCents(cents);
      if (maxCents > cents) formatted = 'From ' + formatted;
      return formatted;
    }
    if (mode === 'amazon') return el.getAttribute('data-amazon-price') || '';
    var retailCents = parseInt(el.getAttribute('data-retail-cents'), 10);
    return retailCents ? formatCents(retailCents) : '';
  }

  function applyThemePrices(scope, mode) {
    (scope || document).querySelectorAll('[data-retail-cents]').forEach(function (el) {
      if (mode === 'retail') {
        var amazon = el.getAttribute('data-amazon-price') || '';
        var visible = el.querySelector('.price__regular .price-item--regular, .price-item--sale');
        if (!amazon || !visible || visible.textContent.trim() !== amazon) return;
      }
      applyThemePrice(el, themePriceText(el, mode));
    });
  }

  function textNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && node.nodeValue.trim()) return node;
    }
    return null;
  }

  function catalogPrice(el) {
    if (!el.getAttribute('data-catalog-price')) {
      var node = textNode(el);
      el.setAttribute('data-catalog-price', (node ? node.nodeValue : el.textContent).trim());
    }
    return el.getAttribute('data-catalog-price');
  }

  function setSnizePrice(el, text) {
    if (!text) return;
    catalogPrice(el);
    if (el.getAttribute('data-audience-price') === text) {
      var current = textNode(el);
      if (current && current.nodeValue.trim() === text) return;
    }
    el.setAttribute('data-audience-price', text);
    var node = textNode(el);
    if (node) node.nodeValue = text;
    else el.insertBefore(document.createTextNode(text), el.firstChild);
  }

  function providerPriceFromCard(card) {
    var min = null;
    var max = null;
    card.className.split(/\s+/).forEach(function (cls) {
      var match = cls.match(/^snize-product-tag-provider--.+--(\d+)$/);
      if (!match) return;
      var cents = parseInt(match[1], 10);
      if (!cents) return;
      if (min === null || cents < min) min = cents;
      if (max === null || cents > max) max = cents;
    });
    if (min === null) return '';
    var formatted = formatCents(min);
    if (max > min) formatted = 'From ' + formatted;
    return formatted;
  }

  function productHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var path = (link.getAttribute('href') || '').split('?')[0];
    var parts = path.split('/products/');
    if (parts.length < 2) return '';
    return decodeURIComponent(parts[1].split('/')[0] || '');
  }

  function remember(handle, data) {
    audienceCache[handle] = data;
    try {
      sessionStorage.setItem('br-audience-v1:' + handle, JSON.stringify(data));
    } catch (error) {}
  }

  function readStored(handle) {
    var cached = audienceCache[handle];
    if (cached) return cached;
    try {
      var raw = sessionStorage.getItem('br-audience-v1:' + handle);
      if (!raw) return null;
      audienceCache[handle] = JSON.parse(raw);
      return audienceCache[handle];
    } catch (error) {
      return null;
    }
  }

  function fetchAudience(handle) {
    var stored = readStored(handle);
    if (stored) return Promise.resolve(stored);
    if (audienceRequests[handle]) return audienceRequests[handle];
    audienceRequests[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=audience-price', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('audience price failed');
        return response.text();
      })
      .then(function (html) {
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('#audience-price-data');
        var data = {
          amazon: node ? node.getAttribute('data-amazon') || '' : '',
          provider: node ? node.getAttribute('data-provider') || '' : ''
        };
        remember(handle, data);
        return data;
      })
      .catch(function () {
        return { amazon: '', provider: '' };
      })
      .finally(function () {
        delete audienceRequests[handle];
      });
    return audienceRequests[handle];
  }

  function providerTextFromPayload(raw) {
    if (!raw) return '';
    var parts = String(raw).split('|');
    var min = parseInt(parts[0], 10);
    var max = parseInt(parts[1] || parts[0], 10);
    if (!min) return '';
    var formatted = formatCents(min);
    if (max > min) formatted = 'From ' + formatted;
    return formatted;
  }

  function applySnizeCard(card, mode) {
    var prices = card.querySelectorAll('.snize-price');
    if (!prices.length) return;

    if (mode === 'retail') {
      prices.forEach(function (el) {
        setSnizePrice(el, catalogPrice(el));
      });
      return;
    }

    if (mode === 'provider') {
      var providerText = providerPriceFromCard(card);
      if (!providerText) {
        var handle = productHandle(card);
        if (!handle) return;
        var storedProvider = readStored(handle);
        if (storedProvider) {
          providerText = providerTextFromPayload(storedProvider.provider);
        } else {
          fetchAudience(handle).then(function () {
            applySnizeCard(card, priceMode());
          });
          return;
        }
      }
      if (!providerText) return;
      prices.forEach(function (el) {
        setSnizePrice(el, providerText);
      });
      return;
    }

    var amazonHandle = productHandle(card);
    if (!amazonHandle) return;
    var storedAmazon = readStored(amazonHandle);
    if (!storedAmazon) {
      fetchAudience(amazonHandle).then(function () {
        applySnizeCard(card, priceMode());
      });
      return;
    }
    if (!storedAmazon.amazon) return;
    prices.forEach(function (el) {
      setSnizePrice(el, storedAmazon.amazon);
    });
  }

  function applySnizePrices(scope, mode) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var cards = root.querySelectorAll ? root.querySelectorAll('.snize-product') : [];
    if (root.classList && root.classList.contains('snize-product')) {
      applySnizeCard(root, mode);
    }
    cards.forEach(function (card) {
      applySnizeCard(card, mode);
    });
  }

  function applyAudienceSearchPrices(root) {
    var mode = priceMode();
    applyThemePrices(root && root.querySelectorAll ? root : document, mode);
    applySnizePrices(root && root.querySelectorAll ? root : document, mode);
  }

  window.applyAudienceSearchPrices = applyAudienceSearchPrices;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyAudienceSearchPrices(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('Searchanise.Loaded', schedule);

  var observer = new MutationObserver(schedule);
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();
